import { Modal, Form, Input, message, InputNumber } from 'antd'

import React, { useState } from 'react'
import { MyValidateMessages } from '../../../../utils/validateMessaage'
import { changeContact } from '../../../../api/api'
import { useEffect } from 'react'
import UploadOnePicture from '../../../../components/upLoadOnePicture/uploadPicture'

export default function EditContact(props) {
  //表单设置
  const { TextArea } = Input
  const { info, setFresh } = props
  const [componentDisabled, setComponentDisabled] = useState(false)
  const onFormLayoutChange = ({ disabled }) => {
    setComponentDisabled(disabled)
  }
  const [form] = Form.useForm()

  //modal设置
  const [open, setOpen] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)

  //向父组件传递图片网址
  const [url, setUrl] = useState()
  const setImgUrl = (url) => {
    setUrl(url)
    // console.log(url);
  }

  useEffect(() => {
    console.log('info', info)
    setUrl(info.image)
  }, [])

  const showModal = () => {
    setOpen(true)
  }
  const handleOk = () => {
    form.setFieldValue('image', url)
    form.validateFields().then((res) => {
      const params = Object.assign(res, { id: info.id })
      changeContact(params).then((res) => {
        console.log(res)
        setOpen(false)
        setFresh((pre) => {
          return !pre
        })
        message.success('修改成功！')
      })
    })
  }
  const handleCancel = () => {
    console.log('Clicked cancel button')
    setOpen(false)
  }

  return (
    <>
      <a onClick={showModal}>编辑</a>
      <Modal
        title="编辑联系人"
        okText="确定"
        cancelText="取消"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <Form
          validateMessages={MyValidateMessages}
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          layout="horizontal"
          onValuesChange={onFormLayoutChange}
          disabled={componentDisabled}
          form={form}
          initialValues={info}
        >
          <Form.Item
            label="描述"
            name="description"
            rules={[
              {
                required: true,
                max: 20,
              },
            ]}
          >
            <TextArea rows={2} placeholder="请输入联系人的描述，上限20字" />
          </Form.Item>

          <Form.Item
            label="联系人图片"
            valuePropName="image"
            name="image"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <UploadOnePicture deliverUrl={setImgUrl} image={info.image} />
          </Form.Item>

          <Form.Item
            label="推荐权重"
            name="weight"
            rules={[
              {
                type: 'number',
                required: true,
                max: 100,
                min: 0,
              },
            ]}
          >
            <InputNumber
              style={{ width: '18vw' }}
              placeholder="请输入0-100的的数字"
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
